import React from "react";
import { PageWrapper } from "components/pages";
import { BookingsList } from "features/BookingsList";

const BookingsListPage = () => {
  return (
    <PageWrapper>
      <BookingsList />
    </PageWrapper>
  );
};

export default BookingsListPage;
